import IconChevronDownSmall from '@picsart/icons/IconChevronDownSmall';
import cls from 'classnames';
import { memo } from 'react';

import { ISingleToolNavigationProps } from '../types';

import useStyles from './styles';
import NavDropdown from './NavDropdown';

function DesktopMenu({ items, analytics, pageName, toolName }: ISingleToolNavigationProps) {
  const classes = useStyles();

  return (
    <nav className={classes.root}>
      {items.map(
        ({ id, label, subLinks, navLink, fillColor, iconColor, icon: Icon, bottomLinks }) => {
          const text = navLink ? (
            <a className={classes.label} href={navLink}>
              {label}
            </a>
          ) : (
            <span className={classes.label}>{label}</span>
          );

          return (
            <div key={id} className={classes.menuItem}>
              <Icon className={classes.icon} />
              {text}
              <IconChevronDownSmall className={cls(classes.icon, classes.arrowIcon)} />
              <NavDropdown
                id={id}
                links={subLinks}
                fillColor={fillColor}
                iconColor={iconColor}
                bottomLinks={bottomLinks}
              />
            </div>
          );
        },
      )}
    </nav>
  );
}

export default memo(DesktopMenu);
